import React from "react";
import theme from "./style";
import {useConfig} from "../../context/configContext";

const WarningSection = (props) => {
  const config = useConfig();
  const classes = theme(config);

  return (
    <div className={classes.wrapper}>
      {props.children}
    </div>
  )
}

export default WarningSection;